import * as React from 'react';
import { useMemo } from 'react';
import Toggler from './Toggler';
import classnames from 'classnames';
import { useSelector } from 'react-redux';

/**
 * Panel component.
 *
 * @param {Object} props
 * @param {String} props.label
 * @param {String} props.feature
 * @param {String} props.status
 * @param {String} props.statusLabel
 * @param {Function} props.callback
 *
 * @returns {JSX.Element}
 */
export default function (props) {
  const {
    label,
    feature = '',
    status = '',
    statusLabel = '',
    callback,
  } = props;

  const features = useSelector(state => state.app.features);

  const isEnabled = useMemo(() => {
    return features.hasOwnProperty(feature) && features[feature] !== false;
  }, [features]);

  const css = {
    root: classnames({
      'user-settings-panel': true,
      'panel': true,
      'panel--disabled': isEnabled === false,
    }),
    badge: classnames({
      'badge': true,
      [`badge--status-${status}`]: status !== ''
    }),
  }

  return (
    <div className={css.root}>
      <div className='panel__header mb-3'>
        <h3 className='h--smaller my-0'>{label}</h3>
        <Toggler enabled={isEnabled} onChangeCallback={callback}/>
        {status && statusLabel && <div className={css.badge}>{statusLabel}</div>}
      </div>
      <div className='panel__content'>
        {props.children}
      </div>
    </div>
  );
}
